import * as React from "react";
import DropdownInput from "./DropdownInput";

const COUNTRIES_PICKLISTTYPEID = 3;

interface ICountryOption {
	text: string;
	value: string;
}
const defaultCountryOptions: ICountryOption[] = [
	{
		text: "",
		value: "",
	},
];

interface IProps {
	// passed props
	country: string;
	onChange: (e: any) => void;
	labelText?: string;
	name?: string;
	className?: string;
	required?: boolean;

	// own props
	countries: PickListItem[];
}

class CountryDropdown extends React.Component<IProps> {
	private countryOptions = defaultCountryOptions;
	constructor(props: IProps) {
		super(props);
		this.countryOptions = this.props.countries.map((p: PickListItem) => {
			return { text: p.description!, value: p.description! };
		});
	}

	public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
		this.countryOptions = nextProps.countries.map((p: PickListItem) => {
			return { text: p.description!, value: p.description! };
		});
	}

	public render() {
		return (
			<DropdownInput
				labelText={this.props.labelText}
				name={this.props.name || "country"}
				defaultOption="-"
				options={this.countryOptions}
				onChange={this.props.onChange}
				value={this.props.country || ""}
				className={this.props.className}
				required={this.props.required}
			/>
		);
	}
}

export default CountryDropdown;
